// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storyAttachment__T5CbN8eowN{width:100%;height:100%;overflow:hidden;position:relative}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/messages/MessageInstagram/messageInstagram.module.scss"],"names":[],"mappings":"AAEA,6BACE,UAAA,CACA,WAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.storyAttachment {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storyAttachment": `storyAttachment__T5CbN8eowN`
};
export default ___CSS_LOADER_EXPORT___;
